import { GET_RAN_DB_DASHBOARD } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getRanDbDashboard = async () => {
  try {
    const response = await apiClient.get(GET_RAN_DB_DASHBOARD);
    return response?.data?.response || response?.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
